<!-- eslint-disable vue/no-v-html -->
<template>
  <CustomTable
    :columns="tableFields"
    :data="tableData"
    :height-tb="true"
    :is-loading="isLoading"
    :custom-class="`recipents-table `"
    :empty-text="
      getComponentUiText('app-modal-manage-vendor-empty-vendor-title-1')
    "
    @update-selected-rows="handleSelectData($event)"
  >
    <template #cell(name)="data">
      <span
        class="tw-text-[#211F58] tw-text-[13px] tw-font-medium tw-font-[Poppins]"
        >{{ data.item.name }}
      </span>
    </template>
    <template #cell(description)="data">
      <span class="tw-text-[#231F20] tw-text-[12px] tw-font-[Poppins]"
        >{{ getDescription(data.item.description) }}
      </span>
    </template>
    <template #cell(url)="data">
      <span class="tw-text-[#387DFF] tw-text-[12px] tw-font-[Poppins]"
        >{{ data.item.url }}
      </span>
    </template>

    <template #cell(action)="data">
      <ButtonShowMore
        :id-popover="'popover-btn-action-manage-vendor-table-' + data.item.id"
        :is-from-notification="true"
      >
        <template #default>
          <CustomDropDownItem
            :style="'normal'"
            :id-text="'app-modal-manage-vendor-edit-vendor-title-1'"
            :style-text="'tw-w-[129px] !tw-leading-[100%]'"
            @click="() => handleEditVendor(data.item)"
          />
          <CustomDropDownItem
            :id-text="'app-modal-manage-vendor-delete-vendor-title-1'"
            :style="'danger'"
            :style-text="'tw-w-[129px] !tw-leading-[100%]'"
            @click="() => handleDeleteVendor(data.item)"
          />
        </template>
      </ButtonShowMore>
    </template>
  </CustomTable>
</template>

<script lang="ts" setup>
import { computed, Ref, ref, watch } from "vue";
import CustomTable from "@/components/common/customTable.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { getComponentUiText } from "@/utils/utilities";
import CustomDropDownItem from "../common/customDropDownItem.vue";
import ButtonShowMore from "../common/setting/buttonShowMore.vue";
import { IVendorProvider } from "@/interfaces/vendor";

const props = defineProps({
  tableData: {
    type: Array as () => IVendorProvider[],
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const tableFields = [
  {
    text: getComponentUiText(
      "app-modal-manage-vendor-current-vendor-table-name-title-1",
    ),
    value: "name",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase !tw-pr-0",
    valueClass: "xl:tw-w-[240px] tw-w-[180px]",
  },
  {
    text: getComponentUiText(
      "app-modal-manage-vendor-current-vendor-table-description-title-1",
    ),
    value: "description",
    headerClass:
      "tw-text-[#211F58] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    valueClass: "!tw-py-[20px] tw-w-fit md:tw-w-[400px] tw-w-[300px]",
  },
  {
    text: getComponentUiText(
      "app-modal-manage-vendor-current-vendor-table-url-title-1",
    ),
    value: "url",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    valueClass: "!tw-pr-[12px] !tw-py-[20px]",
  },
  {
    text: "",
    value: "action",
    headerClass: "",
    valueClass: "tw-w-[45px] !tw-px-[5px] !tw-py-[14.25px]",
  },
];

const handleSelectData = (selectedIds: number[]) => {
  const data = selectedIds.map((id) =>
    props.tableData.find((item) => item.id === id),
  );
  emit("select:row", data);
};

const getDescription = (description: string) => {
  const div = document.createElement("div");
  div.innerHTML = description;
  return div.textContent || div.innerText || "";
};

const handleDeleteVendor = (item: IVendorProvider) => {
  emit("delete:vendor", item);
};

const handleEditVendor = (item: IVendorProvider) => {
  emit("edit:vendor", item);
};

const emit = defineEmits(["select:row", "delete:vendor", "edit:vendor"]);
</script>

<style lang="scss" scoped>
:deep(.table-header) {
  background-color: #fcfcfd !important;
}
</style>
